/**
 * SOLOMON — Public Privacy Policy page for the consent funnel.
 * Static content, no auth/app providers, no backend. Routed at /privacy on
 * both solomonhq.com and offer.solomonhq.com. Conservative "we do not sell or
 * share" posture. Attorney review is an internal follow-up (see the privacy
 * spec) — NOT stated on this page.
 */
import './OfferLanding.css';

const BRAND_NAME = 'Reid Management';
const EFFECTIVE_DATE = 'June 30, 2026';
const PRIVACY_EMAIL = 'privacy@solomonhq.com';

export default function PrivacyPolicy() {
  return (
    <div className="offer-root">
      <div className="offer-bokeh" aria-hidden="true" />
      <header className="offer-masthead">
        <span className="offer-wordmark">{BRAND_NAME}</span>
      </header>

      <main className="offer-legal">
        <a className="offer-legal-back" href="/">← Back</a>
        <h1 className="offer-legal-title">Privacy Policy</h1>
        <p className="offer-legal-meta">Effective {EFFECTIVE_DATE}</p>

        <p>
          {BRAND_NAME} is a New Jersey company that buys homes for cash, serving
          homeowners including in Indiana. This policy explains what information
          we collect when you use our website and request a cash offer, how we
          use it, and the choices you have.
        </p>

        <h2>Information we collect</h2>
        <p><strong>Information you provide.</strong> When you submit our form, we
          collect your name, phone number, property address, any property
          condition details you share, and a record of the consent you give us to
          contact you.</p>
        <p><strong>Information collected automatically.</strong> We collect
          advertising-attribution parameters from the link you arrive on (such as
          Google Click ID and campaign tags), your IP address at the time you
          submit consent, and information from cookies set by our advertising
          provider (see "Cookies &amp; advertising" below).</p>

        <h2>How we use your information</h2>
        <p>We use your information to evaluate your property and prepare a cash
          offer; to contact you by phone or text about your inquiry,
          consistent with the consent you provided; and to operate, secure, and
          improve our service and advertising.</p>

        <h2>Cookies &amp; advertising</h2>
        <p>We use Google's advertising tag (Google Ads), which sets cookies to
          measure the performance of our ads and conversions. You can learn more
          in{' '}
          <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>{' '}
          and control ad personalization in{' '}
          <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">Google's Ads Settings</a>.</p>

        <h2>How we share information</h2>
        <p><strong>We do not sell or share your personal information</strong> with
          third parties for their own marketing. We share information only with
          service providers who help us operate — for example, Google for
          advertising and analytics, and data-verification vendors that help us
          confirm property or ownership information — under confidentiality
          obligations, and as required by law.</p>

        <h2>Your choices &amp; rights</h2>
        <p>You can opt out of calls and texts at any time by replying STOP or
          telling us. You can request access to or deletion of your information by
          emailing{' '}
          <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>, and we honor
          do-not-contact requests. Residents of some states may have additional
          rights to access or delete their information — contact us to exercise
          them.</p>

        <h2>Data retention &amp; security</h2>
        <p>We keep your information as long as needed for the purposes described
          here and to meet legal requirements, and we apply reasonable safeguards
          to protect it.</p>

        <h2>Children's privacy</h2>
        <p>Our site is not directed to minors, and we do not knowingly collect
          their personal information.</p>

        <h2>Changes to this policy</h2>
        <p>We may update this policy from time to time. The effective date at the
          top reflects the latest version.</p>

        <h2>Contact us</h2>
        <p>{BRAND_NAME} · <a href={`mailto:${PRIVACY_EMAIL}`}>{PRIVACY_EMAIL}</a>.
          This policy is governed by the laws of the State of New Jersey.</p>
      </main>
    </div>
  );
}
